import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

const registerServiceWorker = () => {
  void import("virtual:pwa-register").then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
};

const scheduleServiceWorkerRegistration = () => {
  window.setTimeout(registerServiceWorker, 5000);
};

if (document.readyState === "complete") {
  scheduleServiceWorkerRegistration();
} else {
  window.addEventListener("load", scheduleServiceWorkerRegistration, { once: true });
}

createRoot(document.getElementById("root")!).render(<App />);
